import { ToastContainer, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import PropTypes from 'prop-types'

import * as S from './styled'

const transitions = {
  slide: Slide,
  zoom: Zoom,
  flip: Flip,
  bounce: Bounce
}

const Toastify = ({
  position = 'bottom-center',
  autoClose = 4000,
  hideProgressBar = true,
  closeOnClick = true,
  draggable = false,
  transition = 'Slide',
  ...props
}) => (
  <S.ToastifyContainer>
    <ToastContainer
      position={position}
      autoClose={autoClose}
      hideProgressBar={hideProgressBar}
      closeOnClick={closeOnClick}
      draggable={draggable}
      transition={transitions[transition] || transitions.slide}
      {...props}
    />
  </S.ToastifyContainer>
)

Toastify.propTypes = {
  position: PropTypes.oneOf([
    'top-right',
    'top-center',
    'top-left',
    'bottom-right',
    'bottom-center',
    'bottom-left'
  ]),
  autoClose: PropTypes.number,
  hideProgressBar: PropTypes.bool,
  closeOnClick: PropTypes.bool,
  draggable: PropTypes.bool,
  transition: PropTypes.oneOf(Object.keys(transitions))
}
export default Toastify
